module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon12.9530f1af.png";